'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const MoreCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="More.com"
        title={
          t.customerStories[
            'More.com is automating +67% with all-time high customer satisfaction'
          ]
        }
        subtitle={
          t.customerStories[
            "Open's AI agent automates 67%+ of support across email and chat for More.com's multi-market ticketing operations. Customers get instant help with bookings, changes, and inquiries across European markets."
          ]
        }
        stats={[
          {
            value: isRTL ? '٣٠ مليون' : '30M',
            label: t.customerStories['tickets sold'],
          },
          {
            value: isRTL ? '٨٠٪' : '80%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? t.customerStories['All-time high'] : 'ATH',
            label: t.customerStories['CSAT score'],
          },
        ]}
      />

      <CaseStudyBody
        aside={{
          logoAlt: 'More.com',
          customerName: 'More.com',
          company: t.customerStories['more_company_description'],
          industry: t.customerStories['Events & Ticketing'],
          websiteUrl: 'https://www.more.com',
          extras: [
            {
              label: t.customerStories.Markets,
              value: t.customerStories['Multiple European markets'],
            },
          ],
          keyResults: [
            t.customerStories['• 67%+ automation rate'],
            t.customerStories['• All-time high CSAT score'],
            t.customerStories['• Email and chat covered'],
            t.customerStories['• Multi-market operations'],
          ],
        }}
      >
        <p>{t.customerStories['more_intro']}</p>

        <h2>{t.customerStories['more_scale_title']}</h2>
        <p>{t.customerStories['more_scale_p1']}</p>
        <p>{t.customerStories['more_scale_p2']}</p>
        <p>{t.customerStories['more_scale_p3']}</p>

        <h2>{t.customerStories['more_solution_title']}</h2>
        <p>{t.customerStories['more_solution_p1']}</p>
        <p>{t.customerStories['more_solution_p2']}</p>
        <p>{t.customerStories['more_solution_p3']}</p>

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['more_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٨٠٪' : '80%',
            },
            {
              metric: t.customerStories['CSAT score'],
              impact: t.customerStories['All-time high'],
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email and chat'],
            },
            {
              metric: t.customerStories['Markets covered'],
              impact: t.customerStories['Multiple European markets'],
            },
          ]}
        />

        <p>{t.customerStories['more_results_p1']}</p>

        <h2>{t.customerStories['more_impact_title']}</h2>
        <p>{t.customerStories['more_impact_p1']}</p>
        <p>{t.customerStories['more_impact_p2']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default MoreCaseStudy;
